"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _BirdsBackground = _interopRequireDefault(require("../BirdsBackground/BirdsBackground"));

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    stepContainer: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      maxWidth: '100%',
      background: palette.common.white,
      flex: '1 1 auto',
      overflow: 'hidden'
    },
    scrollableArea: {
      overflowY: 'auto',
      height: '100%'
    },
    stepContent: {
      padding: spacing(0, 9),
      margin: spacing(0, 'auto'),
      maxWidth: 1440
    }
  };
});

var BuilderStepperContainer = function BuilderStepperContainer(_ref2) {
  var children = _ref2.children;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: classes.stepContainer
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: classes.scrollableArea
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: classes.stepContent
  }, /*#__PURE__*/_react.default.createElement(_material.Box, null, children))), /*#__PURE__*/_react.default.createElement(_BirdsBackground.default, null));
};

var _default = BuilderStepperContainer;
exports.default = _default;